module.exports = __webpack_public_path__ + "img/card.59df8871.svg";